export {
  InputField,
  type InputFieldProps,
} from '../../compositions/shared/InputField';
